import React, { useState } from "react";

const SelectField = ({ placeholder, options = [], value, onChange, error, className = "" }) => {
  const [searchTerm, setSearchTerm] = useState("");
  const [isOpen, setIsOpen] = useState(false);

  const filteredOptions = options.filter(option =>
    option.name_en.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <div className="relative w-full">
      <div
        className={`appearance-none border border-slate-300 bg-neutral-50 focus:ring-1 focus:ring-slate-300 focus:outline-none text-gray-400 font-bold px-4 py-3 w-full sm:w-[427px] h-12 rounded-xl cursor-pointer ${
          error ? "border-red-600 text-red-600" : ""
        } ${className}`}
        onClick={() => setIsOpen(!isOpen)}
      >
        {value ? options.find(opt => opt.name_en === value)?.name_en : placeholder}
      </div>
      
      {/* Dropdown menu */}
      {isOpen && (
        <div className="absolute z-10 mt-1 w-full sm:w-[427px] bg-white border border-gray-300 rounded-xl shadow-lg">
          <input
            type="text"
            className="w-full px-4 py-2 border-b border-gray-300 focus:outline-none text-gray-400 font-bold" 
            placeholder="Search..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
          <div className="max-h-40 overflow-y-auto">
            {filteredOptions.length > 0 ? (
              filteredOptions.map((option, idx) => (
                <div
                  key={idx}
                  className="px-4 py-2 cursor-pointer hover:bg-gray-200 text-gray-400 font-bold"
                  onClick={() => {
                    onChange({ target: { value: option.name_en, name: "area" } });
                    setIsOpen(false);
                  }}
                >
                  {option.name_en}
                </div>
              ))
            ) : (
              <div className="px-4 py-2 text-gray-500">No options found</div>
            )}
          </div>
        </div>
      )}

      {/* Custom dropdown arrow */}
      <div className="absolute right-3 top-1/2 transform -translate-y-1/2 pointer-events-none">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
          className="w-4 h-4 text-gray-600"
        >
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7" />
        </svg>
      </div>

      {/* Optional error text display */}
      {error && <p className="text-red-600 text-sm mt-1">{error}</p>}
    </div>
  );
};

export default SelectField;
